import React, { Suspense } from 'react';
import { useLocation } from 'react-router-dom';
import { GlobalStyle } from './screens/sms/styles';
import { ROUTE_CALLBACK, ROUTE_NOTIFY, ROUTE_SDK, ROUTE_SDKS, ROUTE_SHARE, ROUTE_UNKNOWN } from './defaults/routes';
import LoadingScreen from '../../../../../libs/shared-ui/src/lib/loading';

const App = React.lazy(() => import('./app'));
const Sdk = React.lazy(() => import('./screens/sdk'));
const Sdks = React.lazy(() => import('./screens/sdks'));
const Notify = React.lazy(() => import('./screens/sms/notify'));
const Callback = React.lazy(() => import('./screens/sms/callback'));
const Share = React.lazy(() => import('./screens/sms/share'));
const Unknown = React.lazy(() => import('./screens/sms/unknown'));

const getComponentByRoute = (pathName) => {
  switch (pathName) {
    case ROUTE_SDK:
      return <Sdk />;
    case ROUTE_SDKS:
      return <Sdks />;
    case ROUTE_NOTIFY:
      return <Notify />;
    case ROUTE_CALLBACK:
      return <Callback />;
    case ROUTE_SHARE:
      return <Share />;
    case ROUTE_UNKNOWN:
      return <Unknown />;
    default:
      return <App />;
  }
};

const PublicApp = () => {
  const location = useLocation();

  return (
    <>
      <GlobalStyle />
      <Suspense fallback={<LoadingScreen />}>
        {getComponentByRoute(location.pathname)}
      </Suspense>
    </>
  );
};

export default PublicApp;
